import React from 'react';

import cls from 'classnames';

import Button from '@ott/button';
import CheckIcon from '@ott/icon-check';
import PlusIcon from '@ott/icon-plus';
import type { SelectOption } from '@ott/select';

import { newCardOption } from '../../../../../constants';
import { getIssuingNetworkByCardNumber } from '../../../../../helpers';
import { CardNetworkIcon } from '../CardNetworkIcon';

import styles from './Option.scss';

type Props = {
  option: SelectOption;
  isActive: boolean;
  isHovered: boolean;
};

export const Option = (props: Props) => {
  const {
    option: { label, value },
    isActive,
    isHovered,
  }: Props = props;

  if (value === newCardOption.value) {
    return (
      <Button
        type="button"
        className={styles.newCardButton}
        childrenClassNames={{ children: styles.newCardButtonChildren }}
        specificLocators="new-card-button"
      >
        <div className={styles.newCardButtonContent}>
          <span>{label}</span>
          <PlusIcon className={styles.plusIcon} />
        </div>
      </Button>
    );
  }

  const issuingNetwork = getIssuingNetworkByCardNumber(label);

  return (
    <div
      className={cls(styles.option, { [styles.active]: isActive, [styles.hovered]: isHovered })}
      data-locator="cards-overlay-option"
      data-id={value}
    >
      <div className={styles.content}>
        <span>{label}</span>
        {isActive && <CheckIcon />}
      </div>
      <CardNetworkIcon issuingNetworkType={issuingNetwork} />
    </div>
  );
};
